import React from 'react'
import { PasswordlessAuthentication } from '@ztechapps/webui.auth'
import { appSettings } from '../../../config/settings'
import { PageTitle } from '../../../components/PageTitle'
import { useContext } from './Context'

export const PasswordlessAuthLayout = () => {
  const { redirectUrl } = useContext()
  const recaptchaSiteKey = appSettings.Google.recaptchaSiteKey

  return (
    <div>
      <PageTitle
        title="Passwordless Sign In"
        description="Sign in to your account using a passwordless authentication method."
      />
      <h4 className="mb-4">Passwordless Sign</h4>
      <PasswordlessAuthentication
        recaptchaSiteKey={recaptchaSiteKey}
        url="/api/auth/passwordless/pp-store"
        redirectUrl={redirectUrl}
      />
    </div>
  )
}
